import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { AccordionDetails } from '@mui/material'
import Accordion, { AccordionProps } from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import { Theme } from '@mui/material/styles'
import { SxProps } from '@mui/system'
import { PropsWithChildren, useId } from 'react'

type Props = PropsWithChildren<
  {
    title: string
    noPadding?: boolean
    secondary?: boolean
  } & AccordionProps
>

const detailsSx = {
  counterReset: 'accordion',
  ['& > .MuiBox-root']: {
    ['&:last-child']: {
      borderBottom: 0,
      ['& > .MuiBox-root:last-child']: {
        borderBottom: 0,
      },
    },
    ['& > .MuiBox-root:last-child  > .MuiBox-root:last-child']: {
      borderBottom: 0,
    },
  },
}

const noPaddingDetailsSx = {
  ...detailsSx,
  padding: 0,
}

const secondarySx: SxProps<Theme> = (theme) => ({
  background: theme.palette.common.white,
  counterIncrement: 'accordion',
  ['&:before']: {
    display: 'inline-block',
    content: 'counter(accordion)',
    minWidth: theme.spacing(1.125),
    marginRight: theme.spacing(0.25),
  },
})

export const AccordionSection = ({
  title,
  children,
  noPadding,
  secondary,
}: Props) => {
  const id = useId()

  return (
    <Accordion defaultExpanded>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel-${id}-content`}
        id={`panel-${id}-header`}
        sx={secondary ? secondarySx : undefined}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails
        sx={noPadding ? noPaddingDetailsSx : detailsSx}
        id={`panel-${id}-content`}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default AccordionSection
